import InstallBanner from './InstallBanner';

export default InstallBanner;
